{
  "version": 1,
  "asset_id": "c576486c-030c-4c43-89f8-73cff750e8fe",
  "project_id": "5ebebed5-d757-4c4f-9e26-a06d6761c2a0",
  "url": "/__l5e/assets-v1/c576486c-030c-4c43-89f8-73cff750e8fe/wolf-spedition.png",
  "r2_key": "a/v1/5ebebed5-d757-4c4f-9e26-a06d6761c2a0/c576486c-030c-4c43-89f8-73cff750e8fe/wolf-spedition.png",
  "original_filename": "wolf-spedition.png",
  "size": 91908,
  "content_type": "image/png",
  "created_at": "2026-06-25T00:54:03Z"
}
